import { rule } from '../../domain/badge-composition-rule.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const behaviorRules = composition => {
  const { variantIs, check } = composition.checkers;

  return [
    rule('computed/aspect/style/z-index')
      .when(variantIs('mid').or(variantIs('island')))
      .set(() => ({
        aspect: {
          style: {
            'z-index': composition.aspect.baseZIndex,
          }
        }
      })),

    rule('header/clickable')
      .when(variantIs('header'))
      .when(check(() => composition.input.certificateUrl))
      .set(() => ({
        parts: {
          aubySeal: {
            clickable: true
          },
        }
      })),
  ];
};
